<script>
import client from "FrontendJsAssets/common/client";
import { formatPrice } from "FrontendJsAssets/common/format";
import { checkResolution } from 'Functions/helpers';
import { initializeLightgallery } from 'Common/lightgallery';
import { buildStars } from "Functions/rating";
import { initTippy } from 'Functions/tippy';
import { initCountdowns } from "Functions/countdown";

export default {
    name: 'product',
    components: {
        'variation-select': () => import('VueComponents/Product/VariationSelect'),
        'shipping-info': () => import('VueComponents/ShippingInfo')
    },
    props: {
        initialData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            product: this.initialData,
            accessoryInput: 0,
        }
    },
    async mounted() {
        await this.$nextTick()

        for (const lightboxHolderItem of this.$el.querySelectorAll('.js-lightbox-holder')) {
            lightboxHolderItem.classList.remove('initialized')
        }

        for (const lightboxItem of this.$el.querySelectorAll('.js-lightbox')) {
            lightboxItem.classList.remove('initialized')
        }

        const productTabsEl = document.getElementById('product-tabs');
        if (productTabsEl) {
            productTabsEl.reloadTriggersAndTargets()
        }

        initializeLightgallery();
        buildStars();

        if (window.aLazyLoad) {
            // https://riesenia.atlassian.net/browse/DUB-848
            for (const lazyLoadItem of this.$el.querySelectorAll('.js-lazy.loading')) {
                lazyLoadItem.classList.remove('entered')
                lazyLoadItem.classList.remove('loading')
                delete lazyLoadItem.dataset.llStatus
            }

            window.aLazyLoad.update();
        }

        const customFormsEl = document.querySelector('.js-custom-forms')
        if (customFormsEl) {
            customFormsEl.classList.remove('is-loading')
        }

        initTippy('.js-custom-check-content-tippy', {
            trigger: 'manual',
            placement: 'top-end',
            popperOptions: {
                modifiers: [{
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-end'],
                        boundary: 'document',
                    },
                }],
            }
        })

        initTippy('.js-tippy-shipping-prices', {
            onShow(instance) {
                if (window.customCachedShippingPricesResponse) {
                    return instance.setContent(window.customCachedShippingPricesResponse)
                }

                instance.setContent('<div class="c-shipping-prices-tooltip is-loading"></div>')

                if (!instance.reference.dataset.remoteUrl) return

                client.get(instance.reference.dataset.remoteUrl)
                    .then((response) => {
                        instance.setContent(response.data)

                        window.customCachedShippingPricesResponse = response.data
                    })
                    .catch((error) => {
                        console.log(error);
                        instance.setContent(`<div class="c-shipping-prices-tooltip"><div class="h-is-red">${error?.response?.data?.message}</div></div>`)
                    });
            },
        });

        if (window.customFormsToInitialize?.length) {
            for (const customFormInitialize of window.customFormsToInitialize) {
                customFormInitialize()
            }
        }

        initCountdowns()

        if (this.product.first_variation?.accessories?.length) {
            const acessoryPresentInCart = this.product.first_variation.accessories.find(item => item.presentInCart === true);

            if (acessoryPresentInCart) {
                this.accessoryInput = acessoryPresentInCart.id;
            }
        }
    },
    methods: {
        formatPrice: formatPrice.bind(this),
        getPrice(field = 'price', format = true, withVat = null, quantity = 1) {
            if (withVat === null) {
                withVat = window.Eshop.options.pricesWithVat
            }

            const finalPrice = this.product[`${field}${withVat ? '_vat' : ''}`] * quantity

            if (format) {
                return this.formatPrice(finalPrice)
            }

            return finalPrice
        },
        variationChanged(variationData) {
            this.accessoryInput = 0;

            this.$nextTick(() => {
                if (variationData.product?.first_variation?.accessories?.length) {
                    const acessoryPresentInCart = variationData.product.first_variation.accessories.find(item => item.presentInCart === true);

                    if (acessoryPresentInCart) {
                        this.accessoryInput = acessoryPresentInCart.id;
                    }
                }
            })
        },
        accessoryIsChecked(accessoryId) {
            return this.accessoryInput === accessoryId
        }
    },
    computed: {
        customSavings() {
            return this.formatPrice(this.getPrice('old_price', false) - this.getPrice('price', false))
        },
        customActionPercentage() {
            return Math.ceil(100 - 100 / this.product.old_price * this.product.price)
        },
    },
    watch: {
        accessoryInput() {
            const accessoryRecommendedAmount = this.product?.first_variation?.accessories?.find(accessory => accessory.id === this.accessoryInput)?.recommended_amount || 0;

            Cart.moduleData('.c-product-cart__buy [name="module_data"]', 'accessoryId', this.accessoryInput)
            Cart.moduleData('.c-product-cart__buy [name="module_data"]', 'accessoryQuantity', accessoryRecommendedAmount)
        }
    }
};
</script>
